import { Container, Row, Col } from "react-bootstrap";
import "./ProductSection.css";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import { getProduct } from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect } from "react";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";

function ProductSection() {
  const dispatch = useDispatch();

  const { userdata } = useContext(Context);
  console.log(userdata, "userdatauserdata");

  const productsdetails = useSelector((state) => state.product.productdetails);

  const products = productsdetails?.products;
  const productdetail = productsdetails?.products?.productdetails;

  useEffect(() => {
    dispatch(getProduct());
  }, [dispatch]);

  const navigate = useNavigate();

  return (
    <section className="product-section">
      <img
        src="images\home\productsection\leftSide.png"
        alt="not"
        className="side-image side-image-left"
      />

      <img
        src="images\home\productsection\rightSide.png"
        alt="not"
        className="side-image side-image-right"
      />

      <Container>
        <div className="product-container">
          <Row className="align-items-center">
            {/* Left Side  */}
            <Col lg={5} md={6} sm={12} className="text-center">
              <img
                // src="/images/home/productsection/product.png"
                src={`${IDS.IMG_URL}${products?.image}`}
                alt="Spirulina"
                className="product-img"
              />
            </Col>

            {/* Right Side  */}
            <Col lg={7} md={6} sm={12}>
              <div className="product-content">
                <div className="bg-box">
                  {/* <h2>Spirulina Superfood Supplement</h2> */}
                  <h2>{products?.name}</h2>
                  <p className="subtitle">
                    {/* Pure Nutrition For Everyday Wellness */}
                    {products?.description}
                  </p>

                  <p className="price">
                    <div className="dot"></div>₹ {products?.price}/-{" "}
                    <span>Only</span>
                  </p>
                </div>
                <ul className="product-details">
                  <li>Form: {productdetail?.form}</li>
                  <li>Net Quantity: {productdetail?.quantity} Tablets</li>
                  <li>Suitable For: {productdetail?.suitable}</li>
                  <li>Usage: {productdetail?.usage}</li>
                </ul>

                {/* {userdata?.order?.length === 0 ? ( */}
                <WhiteButton
                  title={"Buy Now"}
                  bg="#ffff"
                  color="#000"
                  hoverColor="#f35f37"
                  hoverBg={"#000"}
                  onClick={() => navigate("/cart")}
                />
                {/* ) : (
                  <p className="already-purchased-text">
                    You have already purchased this product.
                  </p>
                )} */}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default ProductSection;
